// Ce fichier définit les valeurs par defaut du state dans le GlobalContext
// ex: import INITIAL_STATE from '/contexts/INITIAL_STATE';

import I_STATE from './I_STATE';

const currentDate = new Date();

// du 01 jan au 31 dec
const from_01Jan = currentDate.getFullYear()+'-01-01';
const to_31dec = currentDate.getFullYear()+'-12-31';

// du mois courant à year+1
// ex : 2025-01-01 au 2025-12-31
const currentMonth = currentDate.getMonth();  // 0 - 11
const currentMonthFormatted = `${currentMonth < 9 ? '0' : ''}${currentMonth + 1}`;
const toMonth = currentMonth > 0 ? currentMonth - 1 : 11;
const toMonthFormatted = `${toMonth < 9 ? '0' : ''}${toMonth + 1}`;
const toYear = currentMonth > 0 ? currentDate.getFullYear() + 1 : currentDate.getFullYear();
const toDayFormatted = toMonth === 1 ? '28' :
  (toMonth === 0 || toMonth === 2  || toMonth === 4 || toMonth === 6 ||
    toMonth === 7 || toMonth === 9 || toMonth === 11 ? '31' : '30');
const from_01CurrentMonth = currentDate.getFullYear()+'-'+currentMonthFormatted+'-01';
const to_31PreviousMonth = toYear+'-'+toMonthFormatted+'-'+toDayFormatted;

const INITIAL_STATE: I_STATE = {
  from_date: from_01CurrentMonth,
  to_date: to_31PreviousMonth,
  activity_types: [],
  direction: '',
  hub: '',
  collaborators: [],
  skills: [],
  functions: [],
  billing_customers: [],
  audited_customers: [],
  referentials: [],
  referential_types: [],
  of_number: '',
};
export default INITIAL_STATE;
